import React, { useEffect, useState } from 'react';
import { Font, View, Text, StyleSheet, Image } from '@react-pdf/renderer';

Font.register({
    family: 'Ubuntu',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'normal',
            fontStyle: 'italic',
        },
    ],
});

const imagePathBeginner = "https://sms.cooledsys.com/beginner_indicator.jpg";
const imagePathProficient = "https://sms.cooledsys.com/proficient_indicator.jpg";
const imagePathAdvanced = "https://sms.cooledsys.com/advanced_indicator.jpg";
const imagePathCheckboxEmpty = "https://sms.cooledsys.com/checkbox_emtpy.png";
const imagePathCheckboxTick = "https://sms.cooledsys.com/checkboxtick.png";


const SubjectFeedback = ({ subjectObj }) => {
    const [subject, setSubject] = useState("");
    const [rating, setRating] = useState([]);
    const [feedback, setFeedback] = useState("");

    useEffect(() => {
        // console.log("SubjectFeedback called");
        if (subjectObj) {
            // console.log("subjectObj", subjectObj);
            setSubject(subjectObj.subject);
            setRating(subjectObj.rating);
            setFeedback(subjectObj.feedback);
        }
    }, [subjectObj]);


    return (
        <View style={[styles.container]}>
            <View style={[styles.topRow]}>
                <View style={[styles.colLeft]}>
                </View>
                <View style={[styles.colRight, { backgroundColor: "orange" }]}>
                    <Text style={[styles.textInstruction]}>Performance Level Descriptors</Text>
                </View>
            </View>
            <View style={[styles.main]}>
                <View style={[styles.languageBlock]}>
                    <View style={[styles.colLeft, { backgroundColor: "orange" }]}>
                        <Text style={[styles.textLabelLanguage]}>{subject}</Text>
                    </View>
                    <View style={[styles.colRight]}>
                        <View style={[styles.imageContainer]}>
                            <Image src={imagePathBeginner} style={styles.imageStyle} />
                            <Text style={styles.indicator_text}>BEGINNER</Text>
                        </View>
                        <View style={[styles.imageContainer]}>
                            <Image src={imagePathProficient} style={styles.imageStyle} />
                            <Text style={styles.indicator_text}>PROFICIENT</Text>
                        </View>
                        <View style={[styles.imageContainer]}>
                            <Image src={imagePathAdvanced} style={styles.imageStyle} />
                            <Text style={styles.indicator_text}>ADVANCED</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.assessmentBlock]}>
                    <View style={[styles.abilitiesLabel]}>
                        <Text style={[styles.textLabel]}>ABILITIES</Text>
                    </View>
                    <View style={[styles.assessmentSection]}>
                        <View style={{ flex: 1, }}>
                            <AssessmentRow
                                assessmentLabel="Awareness"
                                labelBgColor="#E3963E"
                                assessValue={rating.a}
                                valueBgColor="#FFDEAD"
                            />
                        </View>
                        <View style={{ flex: 1, }}>
                            <AssessmentRow
                                assessmentLabel="Sensitivity"
                                labelBgColor="#FFDEAD"
                                assessValue={rating.s}
                                valueBgColor="white"
                            />
                        </View>
                        <View style={{ flex: 1, }}>
                            <AssessmentRow
                                assessmentLabel="Creativity"
                                labelBgColor="#E3963E"
                                assessValue={rating.c}
                                valueBgColor="#FFDEAD"
                            />
                        </View>
                    </View>
                </View>
                <View style={[styles.feedbackRow]}>
                    <Text style={[styles.textFeedback]}>{feedback}</Text>
                </View>
            </View>
        </View>
    );
}

const AssessmentRow = ({ assessmentLabel, labelBgColor, assessValue, valueBgColor }) => {
    return (
        <View style={[styles.assessmentRow]}>
            <View style={[styles.assessmentLabel, { backgroundColor: labelBgColor }]}>
                <Text style={[styles.textLabelSmall]}>{assessmentLabel}</Text>
            </View>
            <View style={[styles.assessmentValues, { backgroundColor: valueBgColor }]}>
                <View style={styles.assessmentContainer}>
                    <Image
                        source={assessValue === 10 ? imagePathCheckboxTick : imagePathCheckboxEmpty}
                        style={[styles.imageStyleCheckbox, { color: "green" }]}
                    />
                </View>
                <View style={styles.assessmentContainer}>
                    <Image
                        source={assessValue === 20 ? imagePathCheckboxTick : imagePathCheckboxEmpty}
                        style={[styles.imageStyleCheckbox, { color: "darkgray" }]}
                    />
                </View>
                <View style={styles.assessmentContainer}>
                    <Image
                        source={assessValue === 30 ? imagePathCheckboxTick : imagePathCheckboxEmpty}
                        style={[styles.imageStyleCheckbox, { color: assessValue === 10 ? "green" : "darkgray" }]}
                    />
                </View>

            </View>
        </View>
    );
}


const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: "column",
        // border: '1px solid blue',
    },
    topRow: {
        height: 20,
        flexDirection: "row",
        // border: '1px solid orange',
    },
    main: {
        // height: 140,
        flexDirection: "column",
        border: '1px solid orange',
    },
    languageBlock: {
        height: 55,
        flexDirection: "row",
        // border: '1px solid orange',
    },
    assessmentBlock: {
        height: 60,
        flexDirection: "row",
        borderTop: '1px solid orange',
        borderBottom: '1px solid orange',
    },
    feedbackRow: {
        height: 50,
        paddingHorizontal: 10,
        paddingVertical: 5,
    },
    colLeft: {
        flex: 4,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    colRight: {
        flex: 5,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    abilitiesLabel: {
        flex: 2,
        justifyContent: "center",
        alignItems: "center",
    },
    assessmentSection: {
        flex: 7,
        flexDirection: "column",
        // border: '1px solid red',
    },
    assessmentRow: {
        flex: 1,
        flexDirection: "row",
        // border: '1px solid black',
    },
    assessmentLabel: {
        flex: 2,
        justifyContent: "center",
        alignItems: "left",
    },
    assessmentValues: {
        flex: 5,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    assessmentContainer: {
        flex: 1,
        // padding: 5,
        justifyContent: "center",
        alignItems: "center",
    },
    imageContainer: {
        flex: 1,
        // padding: 5,
        justifyContent: "space-around",
        alignItems: "center",
    },
    imageStyle: {
        height: 36,
        width: 64,
    },
    imageStyleCheckbox: {
        height: 15,
        width: 15,
    },
    textInstruction: {
        // marginTop: 100,
        fontSize: 13,
        textAlign: 'center',
        color: "white",
    },
    textLabelLanguage: {
        fontSize: 18,
        textAlign: 'center',
        color: "white",
    },
    indicator_text: {
        fontSize: 10,
        textAlign: 'center'
    },
    textLabel: {
        fontSize: 18,
        textAlign: 'center'
    },
    textLabelSmall: {
        fontSize: 10,
        textAlign: 'center'
    },
    textFeedback: {
        fontSize: 11,
        textAlign: 'left',
        textDecoration: "underline",
    },
    checkbox: {
        fontSize: 16, // Adjust the size of the checkbox
    },
});

export default SubjectFeedback;
